<script setup lang="ts">
import { computed, ref, type Ref } from 'vue'
import { setName, type Name, saveUserInfo, lastInvitation } from '@/composables/user/users'
import { CODE_OK } from '@/apis/code'
import { handleErr } from '@/composables/exception/handler'
import { ElMessage } from 'element-plus'
import { renderMessage } from '@/utils/util'
import type { CommonResponse } from '@/apis/api'
import { useRouter } from 'vue-router'
import { OPEN_URL_INVITATION } from '@/constants'
import { useI18n } from 'vue-i18n'
import { isEmpty } from '@/utils/util'
import { isNotEmpty } from '@/utils/util'
import { redirectUrl } from '@/utils/routerShim'
import { ElDialog } from 'element-plus'
const { t } = useI18n()
const router = useRouter()
// === 1. 内部状态管理 ===
const visible = ref(false)
const fullName: Ref<string> = ref('')

let resolvePromise: ((result: boolean) => void) | null = null

const open = () => {
  fullName.value = ''
  visible.value = true

  return new Promise<boolean>((resolve) => {
    resolvePromise = resolve
  })
}

defineExpose({
  open
})

// 处理取消
const handleCancel = () => {
  visible.value = false
  // 告诉父组件：用户取消了 (返回 false)
  if (resolvePromise) {
    resolvePromise(false)
    resolvePromise = null
  }
}

// 处理提交
async function preCommit() {
  const body: Name = {
    fullName: fullName.value,
    firstName: '',
    middleName: '',
    familyName: ''
  }
  const { data, error, statusCode } = await setName(body)
  const resData = data as Ref<CommonResponse<any>>

  if (error.value) {
    handleErr(resData, error, statusCode)
    // 报错了不一定要关闭弹窗，可以让用户重试
  } else {
    if (resData.value.code === CODE_OK) {
      saveUserInfo(resData.value.data, null)

      ElMessage({
        message: renderMessage(t('set_real_name.set_success')),
        type: 'success'
      })

      // 核心修改：成功后关闭弹窗，并 resolve(true)
      visible.value = false
      if (resolvePromise) {
        resolvePromise(true) // 告诉父组件：搞定！
        resolvePromise = null
      }
    } else {
      ElMessage({
        message: renderMessage(resData.value.message),
        type: 'warning'
      })
    }
  }
}
</script>
<template>
  <el-dialog v-model="visible" width="370" :show-close="false" :title="null">
    <div relative h-full w-full flex flex-col items-start p-2 class="max-w-md" mt--4 rounded-lg>
      <div text-xl font-bold text-main>{{ $t('set_real_name.label') }}</div>
      <input
        type="text"
        maxlength="40"
        v-model="fullName"
        mt-5
        input-base
        input-base-focus
        key.enter="preCommit"
        :placeholder="$t('set_real_name.real_name')"
        h-13
        text-xl />
      <div text-base text-third mt-5>{{ $t('open_life.real_name_tip') }}</div>
      <div flex w-full items-center gap-4 mt-6>
        <button
          w-full
          rounded-2
          btn-solid
          style="background-color: #eeeeee; color: #000000"
          @click="handleCancel"
          flex-1>
          {{ $t('action.cancel') }}
        </button>
        <button w-full rounded-2 btn-solid @click="preCommit" flex-1>
          {{ $t('action.confirm') }}
        </button>
      </div>
    </div>
  </el-dialog>
</template>
<style scoped>
.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
